<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>Customer Profiles</h2>
                </div>
                <div class="col-md-12 filter-all-customers">
                    <div class="row">
                        <div class='col-md-2'>
                            <b-form-group>
                              <b-form-select
                                  id="input-3"
                                  v-model="query.status"
                                  class="form-control"
                                  :options="filterList"
                                  required
                                  @change="apply"
                              ></b-form-select>
                            </b-form-group>
                        </div>
                        <div v-if="user.kyb" class="col-md-2">
                            <b-form-group>
                                <b-form-select
                                    id="input-3"
                                    v-model="query.type"
                                    class="form-control"
                                    :options="filterCategoryOptions"
                                    required
                                ></b-form-select>
                            </b-form-group>
                        </div>
                        <div v-if="user.kyb" class="col-md-2">
                            <b-form-group>
                                <b-form-select
                                    id="input-3"
                                    v-model="query.profileType"
                                    class="form-control"
                                    :options="filterProfileOptions"
                                    required
                                ></b-form-select>
                            </b-form-group>
                        </div>
                      <div class="col-md-2">
                        <b-form-group>
                          <b-form-select
                              id="input-3"
                              v-model="
                                                query.isSelfServiceRegistration
                                            "
                              class="form-control"
                              :options="onboardingType"
                              required
                          ></b-form-select>
                        </b-form-group>
                      </div>
                      <div class="d-flex"
                      :class="{'col-md-3': user.kyb, 'col-md-5': !user.kyb}">
                      
                        <base-search
                        :class="{'w-100':!user.kyb}"
                            placeholder="Search"
                            @keyword="getKeyword"
                        ></base-search>
                        <button style="margin-left: 5px;min-width: 0%"
                            class="btn btn-primary"
                            type="submit"
                            :class="
                                                loading && showPageLoader
                                                    ? 'disabled'
                                                    : ''
                                            "
                            @click="apply"
                        >
                          <span class="btn-text">Apply</span>
                          <span class="loader"></span>
                        </button>
                      </div>
                      <div
                          v-if=" hasScopes('export-customer-profile')"
                          class="col-md-1 export-file-btn"
                      >
                        <b-form-group>
                          <b-button
                              type="button"
                              variant="secondary"
                              class="secondary-add-btn"
                              @click="exportRecords"
                          >
                            <span class="btn-text">EXPORT</span>
                          </b-button>
                        </b-form-group>
                      </div>
                     
                    </div>
                    <!-- <div v-if="user.kyb" class="row justify-content-end">
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-md-5"></div>

                                <div
                                    v-if="hasScopes('export-customer-profile')"
                                    class="col-md-3 text-right export-file-btn"
                                >
                                    <b-form-group>
                                        <b-button
                                            type="button"
                                            variant="secondary"
                                            class="secondary-add-btn"
                                            @click="exportRecords"
                                        >
                                            <span class="btn-text">EXPORT</span>
                                        </b-button>
                                    </b-form-group>
                                </div>
                               
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                :tbody-tr-class="rowClass"
                @sort-changed="sortingChanged"
            >
                <template slot="kycSummary" slot-scope="data">
                    <div
                        v-b-tooltip.hover
                        class="bar-line"
                        :class="changeBarLineClass(data)"
                        :title="changeBarLineTitle(data)"
                    ></div>
                </template>

                <template slot="pictureURL" slot-scope="data">
                    <div
                        class="profile-area"
                        :class="
                            ['processing', 'archived'].includes(data.item.status) 
                                ? 'disable-color disable'
                                : ''
                        "
                    >
                        <router-link
                            :to="{
                                name: getRouteName(data.item),
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            <div
                                v-if="
                                    data.item.pictureURL != null &&
                                    data.item.pictureURL !=
                                        'customers/no-preview.png'
                                "
                                v-authenticated-image="data.item.pictureURL"
                                class="profile-pic"
                                alt="Profile Image"
                            ></div>
                            <!--Added by SAIF-->
                            <div
                                v-else
                                v-authenticated-image="
                                    'users/blank-profile-pic.png'
                                "
                                class="profile-pic"
                                alt="Profile Image"
                            >
                                <!--Added by SAIF-->
                            </div>
                        </router-link>
                    </div>
                </template>

                <template slot="idenfoId" slot-scope="data">
                    <div
                        class="customer-link"
                        :class="
                        ['processing', 'archived'].includes(data.item.status)
                                ? 'disable-color disable'
                                : ''
                        "
                    >
                        <router-link
                            :to="{
                                name: getRouteName(data.item),
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            {{ data.item.idenfoId }}
                        </router-link>
                    </div>
                </template>

                <template slot="fullName" slot-scope="data">
                    <div
                        class="action-flex"
                        :class="
                        ['processing', 'archived'].includes(data.item.status)
                                ? 'disable-color disable'
                                : ''
                        "
                    >
                        <router-link
                            :to="{
                                name: getRouteName(data.item),
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            <span>
                                <!--{{ data.item.fullName | titleCase }}-->
                                {{ data.item.fullName }}
                            </span>
                        </router-link>
                    </div>
                </template>
                <template slot="uaePassDetails" slot-scope="data">
                    <span>{{ data.item.uaePassDetails && data.item.uaePassDetails.userType ? data.item.uaePassDetails.userType : "" }}</span>
        
                </template>
                <template slot="associatedCompany" slot-scope="data">
                    <div
                        v-b-tooltip.hover="{
                            title: getCompaniesTooltipHtml(data),
                            html: true,
                        }"
                        class="textElipses"
                    >
                        {{
                            data.item.parentCompanies &&
                            data.item.parentCompanies.length
                                ? data.item.parentCompanies.join(', ')
                                : data.item.companyName
                        }}
                    </div>
                </template>
                <template slot="isCRS" slot-scope="data">
                    <span v-if="data.item.isCRS">
                        <i class="icon-wrong" style="color: darkred"></i>
                    </span>
                </template>
                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    <!--{{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}-->
                    <span
                        :class="
                        ['processing', 'archived'].includes(data.item.status) ? 'gray-text' : ''
                        "
                        >{{
                            data.item.createdAt | moment('MMM D, YYYY h:mm a')
                        }}</span
                    >
                </template>
                <template
                    v-if="APP_COUNTRY == 'Pakistan'"
                    slot="idenfoVerificationStatus"
                    slot-scope="data"
                >
                    <base-status
                        :status-type="
                            data.item.idenfoVerificationStatus
                                ? data.item.idenfoVerificationStatus
                                : 'pending'
                        "
                    ></base-status>
                </template>
                <template slot="status" slot-scope="data">
                    <base-status
                        :status-type="data.item.status"
                        class="fa fa-user-time"
                    ></base-status>
                </template>
                <template slot="riskRating" slot-scope="data">
                    <base-status
                        :status-type="
                            data.item.kycSummary &&
                            data.item.kycSummary.riskRating
                                ? data.item.kycSummary.riskRating
                                : 'processing'
                        "
                    ></base-status>
                </template>

                <template slot="action" slot-scope="data">
                    <div class="action-container">
                    <div class="action-review">
                        <base-action
                            v-b-tooltip.hover
                            icon="icon-eye-view"
                            title="View Profile"
                            :class="
                            ['processing', 'archived'].includes(data.item.status)
                                    ? 'disable-color disable'
                                    : ''
                            "
                            @click="
                                $router.push({
                                    name:
                                        data.item.type == 'company'
                                            ? 'company-information'
                                            : 'customer-information',
                                    params: {
                                        id: data.item._id,
                                    },
                                })
                            "
                        ></base-action>
                    </div>
                    <div v-if="isEditProfile" class="action-review">
                        <base-action
                            v-b-tooltip.hover
                            icon="icon-edit"
                            title="Edit Profile"
                            :class="
                                 ['processing', 'archived'].includes(data.item.status) 
                                    ? 'disable-color disable'
                                    : ''
                            "
                            @click="
                                $router.push({
                                    path: `/customer-profiles/edit-profile/${data.item._id}/`,
                                    // name : 'edit-profile',
                                    // params: {
                                    //     id: data.item._id,
                                    // },
                                })
                            "
                        ></base-action>
                    </div>
                    <div class="action-review">
                        <base-action
                            v-b-tooltip.hover
                            :class="
                                data.item.status == 'processing'
                                    ? 'disable-color disable'
                                    : ''
                            "
                            icon="icon-export"
                            title="Download"
                            @click="showConfirmationPopup(data.item)"
                        ></base-action>
                    </div>

                    <div class="action-review">
                        <!-- if action archive -->
                        <base-action
                            v-if="data.item.status == 'inactive'"
                            v-b-tooltip.hover
                            icon="icon-done"
                            title="Activate"
                            :class="
                                data.item.status == 'processing'
                                    ? 'disable-color disable'
                                    : ''
                            "
                            @click="
                                selectedRecord(data.item)
                                updateStatusPopup('active')
                            "
                        ></base-action>
                        <!-- if action activate -->
                        <base-action
                            v-if="data.item.status != 'inactive'"
                            v-b-tooltip.hover
                            :class="
                                data.item.status == 'processing'
                                    ? 'disable-color disable'
                                    : ''
                            "
                            icon="icon-cross-with-circle"
                            title="In-activate"
                            @click="
                                selectedRecord(data.item)
                                updateStatusPopup('inactive')
                            "
                        ></base-action>
                    </div>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <base-records
            path="users/applications"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>

        <export-process-popup
            :id="id"
            :query="query"
            title="Export Customer's Data"
            :url="cancelUrl"
        ></export-process-popup>
        <generic-confirm-popup
            title="Download Zip File"
            :description="descriptionText"
            :on-confirm="downloadZip"
        >
        </generic-confirm-popup>
        <update-user-status-popup
                ref="update-user-status-popup"
                record-type="customer"
                :description="statusDescription"
                :status="statusToUpdate"
                @update-status="updateStatus"
        ></update-user-status-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import GenericConfirmPopup from '../../components/popups/GenericConfirmPopup.vue'
import request from '@/utils/request'
import axios from 'axios'
import { capitalize } from 'lodash'
import UpdateUserStatusPopup from "../../components/popups/UpdateUserStatusPopup";

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        UpdateUserStatusPopup,
        exportProcessPopup,
        GenericConfirmPopup,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            isEditProfile: false,
            APP_COUNTRY: process.env.VUE_APP_COUNTRY,
            APP_URL: process.env.VUE_APP_API_URL,
            canArchive: false,
            canRestore: false,
            selectedCustomer: null,
            popupTitle: null,
            popupMessage: null,
            graphIds: [
                'customer-by-age',
                'customers-by-gender',
                'customers-by-work-type',
                'customers-account-by-month',
                'customers-by-industry',
                'customers-by-nationality',
                'customers-by-residence',
            ],
            routeName: 'customer-information',
            data_downloads: [],
            toggle: false,
            statusDescription:"",
            statusToUpdate:"",
            fields_downloads: {
                updatedAt: {
                    label: 'Created At',
                    sortable: true,
                    tdAttr: {
                        dataname: 'updatedAt',
                    },
                },
                fileName: {
                    label: 'Download Link',
                    sortable: true,
                    tdAttr: {
                        dataname: 'fileName',
                    },
                },
            },
            fields: {
                // pictureURL: {
                //     label: '',
                //     tdClass: 'profile-absolute',
                //     tdAttr: {
                //         dataname: '',
                //     },
                // },
                kycSummary: {
                    label: '',
                    // class: 'min-20',
                    tdAttr: {
                        dataname: 'kycSummary',
                    },
                },
                idenfoId: {
                    label: 'Idenfo Id',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Customer',
                    },
                },
                fullName: {
                    label: 'NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Full Name',
                    },
                    tdClass: 'email-truncate',
                },

                nationality: {
                    key: 'basicInfo.nationality',
                    label: 'COUNTRY',
                    sortable: true,
                    tdAttr: {
                        dataname: 'nationality',
                    },
                },
                // countryOfResidence: {
                //     key: 'basicInfo.countryOfResidence',
                //     label: 'RESIDENCE',
                //     sortable: true,
                //     tdAttr: {
                //         dataname: 'countryOfResidence',
                //     },
                // },
                type: {
                    key: 'type',
                    label: 'Category',
                    sortable: true,
                    formatter: (value) => {
                        if (value) {
                            return _.startCase(value)
                        } else if (value == '' || !value) {
                            return 'Individual'
                        }
                    },
                },
                associatedCompany: {
                    key: 'associatedCompany',
                    label: 'Associated Company',
                    sortable: false,
                    tdAttr: {
                        dataname: 'associatedCompany',
                    },
                },
                isStr: {
                    key: 'isStr',
                    label: 'STR Filed',
                    sortable: false,
                    formatter: (value) => {
                        if (value) {
                            return _.startCase(value)
                        }
                    },
                },
                // isCRS: {
                //     key: 'isCRS',
                //     label: 'Is CRS',
                //     sortable: false,
                //     tdAttr: {
                //         dataname: 'isCRS',
                //     },
                // },
                createdAt: {
                    label: 'REGISTRATION DATE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'createdAt',
                    },
                },

                userName: {
                    label: 'Onboarded By',
                    sortable: true,
                    tdAttr: {
                        dataname: 'userName',
                    },
                    // tdClass: 'email-truncate',
                },
                uaePassDetails: {
                    label: 'UAE PASS',
                    sortable: true,
                    tdAttr: {
                        dataname: 'uaePassDetails',
                    },
                    // tdClass: 'email-truncate',
                },
                idenfoVerificationStatus: {
                    key: 'idenfoVerificationStatus',
                    label: 'Idenfo Verification Status',
                    sortable: true,
                    tdClass: 'text-center status-absolute-pos',
                    thClass: 'text-center',
                    tdAttr: {
                        dataname: 'idenfoVerificationStatus',
                    },
                },
                status: {
                    label: 'STATUS',
                    sortable: true,
                    tdClass: 'text-center status-absolute-pos',
                    thClass: 'text-center',
                    tdAttr: {
                        dataname: 'status',
                    },
                },
                action: {
                    label: 'Actions',
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'Actions',
                    },
                },
            },
            filterList: [
                { text: 'All', value: null },
                { text: 'Pending', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                { text: 'Rejected', value: 'rejected' },
                { text: 'Inactive', value: 'inactive' },
                { text: 'Processing', value: 'processing' }
            ],
            filterCategoryOptions: [
                { text: 'All Category', value: null },
                { text: 'Individual', value: 'individual' },
                { text: 'Company', value: 'company' },
            ],
            onboardingType: [
                { text: 'All Onboarding Type', value: null },
                { text: 'Deeplink Onboarded', value: 'false' },
                { text: 'Self Onboarded', value: 'true' },
            ],
            filterProfileOptions: [
                { text: 'All Relations', value: null },
                { text: 'Citizen', value: 'Citizen' },
                { text: 'Resident Expat', value: 'Resident Expat' },
                {
                    text: 'Non-resident (tourist)',
                    value: 'Non-resident (tourist)',
                },
                { text: 'Customer', value: 'Customer' },
                { text: 'Supplier', value: 'Supplier' },
                { text: 'Third Party', value: 'Third Party' },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
                type: null,
                profileType: null,
                isSelfServiceRegistration: null,
            },
            reset: new Date().getTime(),
            id: null,
            cancelUrl: 'customers/cancel-export',
            selectedTempCustomer: null,
            exportPdf: null,
            descriptionText: 'Proceed with downloading the zip file?',
            isLoading: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
            'user',
        ]),
        formartedItems() {
            // console.log('test 1 item', item)
            if (!this.data) return []
            return this.data.map((item) => {
                // console.log('test item', item)
                this.selectedTempCustomer = item
                item._rowVariant = this.getVariant(item.Status)
                return item
            })
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.user.accountType == 'lite') {
            this.routeName = 'screening-company'
        }
        if (this.APP_COUNTRY != 'Pakistan') {
            delete this.fields['idenfoVerificationStatus']
        }
        if (process.env.VUE_APP_UAE_PASS != 'true') {
            delete this.fields['uaePassDetails']
        }
        var permissions = this.$store.state.authentication.scopes
        this.isEditProfile = permissions.includes('edit-profile')

        localStorage.setItem('goBackUrl', this.$route.name)
        let queryData = JSON.parse(localStorage.getItem('queryData'))
        if (queryData) {
            Object.assign(this.query, queryData)
            localStorage.removeItem('queryData')
        }
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        changeBarLineTitle(data) {
            let riskRatingStatus =
                data.item.kycSummary && data.item.kycSummary.riskRating
                    ? data.item.kycSummary.riskRating
                    : 'processing'
            return capitalize(riskRatingStatus) + ' Risk'
        },
        changeBarLineClass(data) {
            let riskRatingStatus =
                data.item.kycSummary && data.item.kycSummary.riskRating
                    ? data.item.kycSummary.riskRating
                    : 'processing'
            return riskRatingStatus
        },
        rowClass(item, type) {
            // console.log('item', item.status)
            if (item.status == 'inactive' || item.status == 'processing') {
                return 'table-secondary'
            }
            // if (!item || type !== 'row') return
            // if (item.user_id == this.$auth.user.id) return 'table-success'
        },
        /**
         *
         * @return {void}
         */
        getRouteName(item) {
            let routeName =
                item.type == 'company'
                    ? 'company-information'
                    : 'customer-information'
            if (this.user.accountType == 'lite') {
                routeName =
                    item.type == 'company'
                        ? 'screening-company'
                        : 'screening-customer'
            }
            return routeName
        },

        getVariant(status) {
            switch (status) {
                case 1:
                    return 'success'
                case 1:
                    return 'danger'
                default:
                    return 'active'
            }
        },

        async updateStatusPopup(status){
            this.statusToUpdate=status
            if(status=='active')
            {
                this.statusDescription="Are you sure you want to activate this customer?"
            }
            else
            {
                this.statusDescription="Are you sure you want to in-activate this customer?"
            }
            this.$bvModal.show('update-user-status-popup')
        },
        async updateStatus(detailsObj) {
            try {
                this.$store.commit('setLoading', true)
                const { data } = await request({
                    url: '/customers/updateCustomerStatus',
                    method: 'post',
                    data: {
                        customerId: this.selectedTempCustomer._id,
                        status:this.statusToUpdate,
                        statusChangeDetails: detailsObj,
                    },
                })
                if (data)
                 {

                    // this.apply()
                    // let customerData = JSON.parse(
                    //     JSON.stringify(this.customerRecord)
                    // )
                    // this.$store.commit('setCustomerRecord', customerData)
                    this.$bvModal.hide('update-user-status-popup')
                    this.$store.commit(
                        'setSuccess',
                        'Status updated successfully'
                    )

                }
                this.$store.commit('setLoading', false)
            } catch (error) {
                console.log('error on updating customer status:', error)
                this.$store.commit(
                    'setError',
                    'Something went wrong while updating the documents'
                )
                this.$store.commit('setLoading', false)
            }
        },

        getCompaniesTooltipHtml(data) {
            let html = data.item.companyName
            if (data.item.parentCompanies && data.item.parentCompanies.length) {
                html = data.item.parentCompanies[0]
            }
            if (
                data.item.parentCompanies &&
                data.item.parentCompanies.length > 1
            ) {
                html = "<ol style='padding-left:10px'>"
                for (let comp of data.item.parentCompanies) {
                    html += `<li> ${comp} </li>`
                }
                html += '<ol>'
            }
            return html
        }, // End of getKeyword() method
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method
        async onClickButtonDropdown() {
            this.toggle = !this.toggle
            if (this.toggle) {
                let { data } = await request.get(
                    `customers/getExportPdfInfo/${this.dataSegmentId}`,
                    null
                )
                this.data_downloads = data
            }
        },
        /**
         *
         * @return {void}
         */
        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        /**
         *
         * @return {void}
         */
        selectedRecord(record) {
            this.selectedTempCustomer = record
            // console.log('Data array:', this.data)
            //   console.log('Item to toggle color:', record);
            //   const index = this.data.findIndex(i => i._id === record._id);
            //   console.log('Found index:', index);
            //   if (index !== -1) {
            //     this.$set(this.data, index, { ...this.data[index], isGray: !this.data[index].isGray });
            //   } else {
            //     console.error('Item not found in data:', record);
            //   }
            // this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        /**
         *
         * @return {void}
         */
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

        async showConfirmationPopup(tempCustomer) {
            // console.log("run",tempCustomer)
            try {
                // console.log('tempCustomer.idenfoId', tempCustomer)
                const params = {
                    dataSegmentId: this.dataSegmentId,
                }
                // const { data } = await request({
                //     url: `/customers/view-customer/` + tempCustomer.idenfoId,
                //     method: 'get',
                //     params: params,
                // })

                let { data } = await request({
                    url: `customers/document-status/${tempCustomer._id}`,
                })

                // console.log('result data', data)
                this.selectedTempCustomer = data.data
                let searchParams = {
                    timezoneOffset: new Date().getTimezoneOffset(),
                }

                this.$bvModal.show('confirmation-generic-popup')
            } catch (error) {
                console.log(error)
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)

                this.selectedTempCustomer = null
            }
        },

        async downloadZip() {
            try {
                this.descriptionText =
                    'Your request is being processed, please wait...'
                let name = this.selectedTempCustomer.firstName

                if (
                    typeof this.selectedTempCustomer.documentInfo == 'undefined'
                ) {
                    this.$store.commit('setError', 'No Files found')
                    this.$store.commit('setLoading', false)

                    this.selectedTempCustomer = null
                } else {
                    let documents = this.selectedTempCustomer.documentInfo
                        ? this.selectedTempCustomer.documentInfo
                        : null
                    this.$store.commit('setLoading', true)
                    let searchParams = {
                        timezoneOffset: new Date().getTimezoneOffset(),
                    }

                    const response = await axios({
                        method: 'get',
                        url: `${process.env.VUE_APP_API_URL}customers/generateReport/${this.selectedTempCustomer._id}?save=true`,
                        params: searchParams,
                    })
                    if (!response && !response.property) {
                        this.$store.commit(
                            'setError',
                            'Pdf File is not generated'
                        )
                        this.$store.commit('setLoading', false)

                        this.selectedTempCustomer = null
                    }
                    if (response) {
                        this.exportPdf = response.data.data.fileName
                        if (typeof this.exportPdf == 'undefined') {
                            this.$store.commit('setError', 'No Files found')
                            this.$store.commit('setLoading', false)
                            this.selectedTempCustomer = null
                        }
                        
                        let filesArray = []
                        let temp = {}

                        if (this.exportPdf) {
                            temp = {
                                src: 'reports-individual/' + this.exportPdf,
                                title: this.selectedTempCustomer.idenfoId+'-'+name+'.pdf',
                            }
                            filesArray.push(temp)
                        }
                        if (documents.scrutiny.fileName) {
                            let fileName = documents.scrutiny.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `scrutiny.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.custBusInquired.fileName) {
                            let fileName = documents.custBusInquired.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `custBusInquired.${extenstion}`,
                            }
                            
                            filesArray.push(temp)
                        }
                        if (documents.managementApproval.fileName) {
                            let fileName = documents.managementApproval.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `managementApproval.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.firstPayment.fileName) {
                            let fileName = documents.firstPayment.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `firstPayment.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.identity.fileName) {
                            let fileName = documents.identity.fileName
                            const extenstion = fileName.split('.').pop()
                            let title  = documents.identityBack.fileName ? 'identityFront' : 'Passport'
                            if(this.selectedTempCustomer.type=='company')
                        {
                            title=this.getCompanyTitles('identity')
                        }
                            temp = {
                                src: fileName,
                                title: `${title}.${extenstion}`,
                            }
                        
                            filesArray.push(temp)
                        }
                        if (documents.identityBack.fileName) {
                            let fileName = documents.identityBack.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `identityBack.${extenstion}`,
                            }
                    
                            filesArray.push(temp)
                        }
                        // if (documents.utility.fileName) {
                        //     const parts = documents.utility.fileName.split('/')
                        //     temp = {
                        //         src: documents.utility.fileName,
                        //         title: parts[1],
                        //     }
                        //     filesArray.push(temp)
                        // }
                        if (documents.video.fileName) {
                            let fileName = documents.video.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `liveness-video.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.visaPage.fileName) {
                            let fileName = documents.visaPage.fileName
                            const extenstion = fileName.split('.').pop()
                            let title='visa-page'
                            if(this.selectedTempCustomer.type=='company')
                        {
                            title=this.getCompanyTitles('visaPage')
                        }
                            temp = {
                                src: fileName,
                                title: `${title}.${extenstion}`,
                            }
            
                            filesArray.push(temp)
                        }
                        if (documents.fieldEmiratesID.fileName) {
                            let fileName = documents.fieldEmiratesID.fileName
                            const extenstion = fileName.split('.').pop()
                            let title='EmiratesId-front'
                            if(this.selectedTempCustomer.type=='company')
                        {
                            title=this.getCompanyTitles('emiratesId')
                        }
                            temp = {
                                src: fileName,
                                title: `${title}.${extenstion}`,
                            }
                            
                            filesArray.push(temp)
                        }
                        if (documents.fieldEmiratesIDBack.fileName) {
                            let fileName = documents.fieldEmiratesIDBack.fileName
                            const extenstion = fileName.split('.').pop()
                            let title='EmiratesId-back'
                            if(this.selectedTempCustomer.type=='company')
                        {
                            title=this.getCompanyTitles('emiratesIdBack')
                        }
                            temp = {
                                src: fileName,
                                title: `${title}.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.fieldAddressProof.fileName) {
                            let fileName = documents.fieldAddressProof.fileName
                            const extenstion = fileName.split('.').pop()
                            let title='address-proof'
                            if(this.selectedTempCustomer.type=='company')
                        {
                            title=this.getCompanyTitles('addressProof')
                        }
                            temp = {
                                src: fileName,
                                title: `${title}.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.fundsEvidenceDocument.fileName) {
                            let fileName = documents.fundsEvidenceDocument.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `fundsEvidenceDocument.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.wealthEvidenceDocument.fileName) {
                            let fileName = documents.wealthEvidenceDocument.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `wealthEvidenceDocument.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        if (documents.additionalDocument.fileName) {
                            let fileName = documents.additionalDocument.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `additionalDocument.${extenstion}`,
                            }
                            filesArray.push(temp)
                        }
                        
                        if (documents.proofOfEmployment.fileName) {
                            let fileName = documents.proofOfEmployment.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `proofOfEmployment.${extenstion}`,
                            }
                         
                            filesArray.push(temp)
                        }
                        if (documents.EducationalDocument.fileName) {
                            let fileName = documents.EducationalDocument.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `EducationalDocument.${extenstion}`,
                            }
                        
                            filesArray.push(temp)
                        }
                        // if (documents.ocrPicture.fileName) {
                        //     const parts = documents.ocrPicture.fileName.split('/');
                        //     temp = {
                        //         src: documents.ocrPicture.fileName,
                        //         title: parts[1]
                        //     }
                        //     filesArray.push(temp)
                        // }
                        if (documents.picture.fileName) {
                            let fileName = documents.picture.fileName
                            const extenstion = fileName.split('.').pop()
                            temp = {
                                src: fileName,
                                title: `picture.${extenstion}`,
                            }
                            
                            filesArray.push(temp)
                        }
                       
                        if (
                            documents.consentForm &&
                            documents.consentForm.fileName
                        ) {
                            const parts =
                                documents.consentForm.fileName.split('/')
                            temp = {
                                src: documents.consentForm.fileName,
                                title: parts[1],
                            }
                            filesArray.push(temp)
                        }
                        if (
                            documents.licenseFront &&
                            documents.licenseFront.fileName
                        ) {
                            const parts =
                                documents.licenseFront.fileName.split('/')
                            temp = {
                                src: documents.licenseFront.fileName,
                                title: parts[1],
                            }
                            filesArray.push(temp)
                        }
                        if (
                            documents.licenseBack &&
                            documents.licenseBack.fileName
                        ) {
                            const parts =
                                documents.licenseBack.fileName.split('/')
                            temp = {
                                src: documents.licenseBack.fileName,
                                title: parts[1],
                            }
                            filesArray.push(temp)
                        }
                        let otherDocs = documents.otherDocuments
                        if (otherDocs) {
                            for (let i = 0; i < otherDocs.length; i++) {
                                const parts = otherDocs[i].fileName.split('/')
                                temp = {
                                    src:
                                        'customer-documents/' +
                                        otherDocs[i].fileName,
                                    title: otherDocs[i].fileName,
                                }
                                filesArray.push(temp)
                            }
                        }
                        // console.log('final', filesArray)
                        if (filesArray.length > 0) {
                            const fileResponse = await axios({
                                url:
                                    process.env.VUE_APP_FILE_SERVICE_URL +
                                    'download',
                                method: 'POST',
                                data: { files: filesArray },
                                responseType: 'blob', // important
                            })
                            if (fileResponse) {
                                // console.log(fileResponse.data.url)
                                const url = window.URL.createObjectURL(
                                    new Blob([fileResponse.data])
                                )
                                const link = document.createElement('a')
                                link.href = url
                                link.setAttribute(
                                    'download',
                                    name + '_documents.zip'
                                ) //or any other extension
                                document.body.appendChild(link)
                                this.$store.commit(
                                    'setSuccess',
                                    fileResponse.data.message
                                )

                                this.$store.commit('setLoading', false)

                                this.selectedTempCustomer = null
                                link.click()
                            } else {
                                console.log(error)
                                this.$store.commit('setLoading', false)
                            }
                        } else {
                            this.$store.commit('setError', 'No Files found')
                            this.$store.commit('setLoading', false)

                            this.selectedTempCustomer = null
                        }
                    } else {
                        this.$store.commit('setError', 'Pdf is not generated')
                        this.$store.commit('setLoading', false)
                    }
                }
            } catch (error) {
                console.log(error)
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)

                this.selectedTempCustomer = null
            }
        },

        getCompanyTitles(key)
        {
            if(this.selectedTempCustomer)
        {
            if(key=='identity')
        {
            return 'Trade-License'
        }
        if(key=='emiratesId')
        {
            return 'Memorandum-of-Association'
        }
        if(key=='emiratesIdBack')
        {
            return 'Certificate-of-Incorporation'
        }
        if(key=='visaPage')
        {
            return 'Certificate-of-Incumbency'
        }
        if(key=='addressProof')
        {
            return 'Certificate-of-Good-Standing'
        }
       return 'doc'
        }
        },
        /**
         *
         * @return {void}
         */
        async exportRecords() {
            try {
                // this.query.dataSegmentId = this.dataSegmentId

                // let { data } = await request.post('customers/export', null, {
                //     params: this.query,
                // })

                // //this.id = data.data.id
                // this.id = this.CryptoJS.AES.encrypt(
                //     JSON.stringify(data.data.id),
                //     process.env.VUE_APP_CRYPTO_SECERT_KEY
                // ).toString()
                this.$bvModal.show('export-process-popup')
                // this.$toasted.show(data.message, {
                //     type: 'success',
                // })
            } catch (error) {
                //  console.log(error, 'error')
            }
        }, // End of exportRecords() method
    }, // End of Component > mounted
} // End of export default
</script>
<style>
.textElipses {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100px;
}
.gray {
    background-color: gray !important;
}
.action-container {
    display: flex;
    flex-wrap: wrap;
}

.action-review {
    flex: 1 1 50%; /* Each div takes up 50% of the row */
    box-sizing: border-box;
    padding: 5px; /* Optional: add some padding for spacing */
}
</style>
